import useJwt from '@/auth/jwt/useJwt';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {
    products:null,
    product_types:null,
    md_units:null,
    categories:null
  },
  getters: {
    getProducts(state){
      return state.products
    },
    getProductTypes(state){
      return state.product_types
    },
    getMdUnits(state){
      return state.md_units
    },
    getCategories(state){
      return state.categories
    },
  },
  mutations: {
    SET_PRODUCTS: (state, payload) => {
      state.products = payload;
    },
    SET_PRODUCT_TYPES: (state, payload) => {
      state.product_types = payload;
    },
    SET_MD_UNITS: (state, payload) => {
      state.md_units = payload;
    },
    SET_CATEGORIES: (state, payload) => {
      state.categories = payload;
    },
  },
  actions: {
    fetchProducts({ commit },p) {
      p.vm.loading(true);
      useJwt.post('getProducts',p.params).then(response => {
        commit('SET_PRODUCTS', response.data.result);
        p.vm.loading(false);
      }).catch(error => {
        p.vm.loading(false);
        console.log(error)
      });
    },
    fetchProductTypes({ commit },params) {
      useJwt.get('getProductTypes').then(response => {
        commit('SET_PRODUCT_TYPES', response.data.result);
      }).catch(error => console.log(error));
    },
    fetchMdUnits({ commit },params) {
      useJwt.get('getMdUnits').then(response => {
        commit('SET_MD_UNITS', response.data.result);
      }).catch(error => console.log(error));
    },
    fetchCategories({ commit },params) {
      useJwt.get('getCategories').then(response => {
        commit('SET_CATEGORIES', response.data.result);
      }).catch(error => console.log(error));
    },
    newProduct({ commit },p){
      p.vm.loading(true);
      useJwt.post('products', p.params).then(response =>{
        p.vm.loadItems();
        p.vm.$bvModal.hide('modal-edit')
        p.vm.$toast({component: ToastificationContent,props: {title: 'Thêm mới thành công!',icon: 'CheckSquareIcon',variant: 'primary'}})
        p.vm.loading(false);
      })
      .catch(error => {
        p.vm.$toast({component: ToastificationContent,props: {title: 'Lỗi thêm mới',icon: 'AlertTriangleIcon',variant: 'danger'}})
        p.vm.loading(false);
      })
    },
    updateProduct({ commit },p){
      p.vm.loading(true);
      useJwt.put('products',p.params)
      .then(response =>{
        p.vm.loadItems();
        p.vm.$bvModal.hide('modal-edit')
        p.vm.$toast({component: ToastificationContent,props: {title: 'Cập nhật thành công!',icon: 'CheckSquareIcon',variant: 'primary'}})
        p.vm.loading(false);
      })
      .catch(error => {
        p.vm.$toast({component: ToastificationContent,props: {title: 'Lỗi cập nhật',icon: 'AlertTriangleIcon',variant: 'danger'}})
        p.vm.loading(false);
      })
    },
    deleteProduct({ commit },p){
      p.vm.loading(true);
      useJwt.delete(`products/${p.params}`,{})
      .then(response =>{
        p.vm.loadItems();
        p.vm.$toast({component: ToastificationContent,props: {title: 'Xoá sản phẩm thành công!',icon: 'CheckSquareIcon',variant: 'primary'}})
        p.vm.loading(false);
      })
      .catch(error => {
        console.log(error);
        p.vm.$toast({component: ToastificationContent,props: {title: 'Lỗi xoá sản phẩm',icon: 'AlertTriangleIcon',variant: 'danger'}})
        p.vm.loading(false);
      })
    },
    fetchProductDetail({ commit },p) {
      p.vm.isLoading=true;
      p.vm.loading(true);
      useJwt.get('getProducts/'+p.id).then(response => {
        var p_ = response.data.result;
        p_.size = JSON.parse(p_.size)
        p_.attributes = JSON.parse(p_.attributes)
        p_.variants = JSON.parse(p_.variants)
        p_.meta = JSON.parse(p_.meta)
        p_.images = JSON.parse(p_.images)
        p_.categories = JSON.parse(p_.categories)
        if (p_.gifts){
          p_.gifts = JSON.parse(p_.gifts);
        }else{
          p_.gifts = [];
        }
        if (!p_.special_prices){
          p_.special_prices = [];
        }
        if (p_.new_gifts){
          p_.new_gifts = JSON.parse(p_.new_gifts);
        }else{
          p_.new_gifts = [];
        }

        p.vm.currentItem = p_;
        p.vm.isLoading=false;
        p.vm.$bvModal.show('modal-edit')
        p.vm.loading(false);
      }).catch(error => {
        p.vm.isLoading=false;
        p.vm.loading(false);
        console.log(error)
      });
    },
  },
}
